export const secondInMS = 1000;
export const minuteInMS = secondInMS * 60;
export const hourInMS = minuteInMS * 60;
export const dayInMS = hourInMS * 24;
export const weekInMS = dayInMS * 7;
//# sourceMappingURL=Constants.js.map